exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-multiselect[data-v-4dd60b12] {\n  width: 100%;\n}\n.search-input[data-v-4dd60b12] {\n  width: 80%;\n}\n.list-multiselect-options[data-v-4dd60b12] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  max-height: 250px;\n  overflow-x: auto;\n}\n.list-multiselect-option[data-v-4dd60b12] {\n  text-align: left;\n  padding: 10px 15px 10px 15px;\n  cursor: pointer;\n  width: 100%;\n}\n.list-multiselect-option-selected[data-v-4dd60b12] {\n  color: #2962ff;\n  background-color: #eef2ff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dd60b12","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ListMultiselect.vue
// module id = eaUJ
// module chunks = 0